import styled from 'styled-components';
import type { TColorVariant } from '@klv/shared/styles/types';

export const FeaturesImageWrapper = styled.div`
  ${({ theme }) => `
    grid-column: 1 / -1;
    margin-bottom: 2.4rem;
    ${theme.screenSize.s768.mediaQuery} {
      grid-column: 2 / 5;
      margin: -1.2rem 0;
    }
  `}
`;
export const StyledAnchor = styled.a<{ $variant: TColorVariant; }>`
  ${({ theme, $variant }) => `
    display: block;
    &:focus {
      outline: .2rem solid ${theme.featuresList[$variant].imageFocus};
      outline-offset: 0;
    }
    ${theme.screenSize.s768.mediaQuery} {
      &:focus {
        outline: .4rem solid ${theme.featuresList[$variant].imageFocus};
        outline-offset: 0;
      }
    }
  `}
`;
